import {IBigWinLevel, IWinRatios} from "../interfaces/Interface";
import {WinRatioType} from "../enums/Enum";

export class Config {
    public static DEFAULT_REEL_SET: string[][] = [
        ["L1", "L2", "S1", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "S2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "S1", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "XHOLE", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "S2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "S1", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
    ]
    public static FS_REEL_SET: string[][] = [
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "S2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "XHOLE", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "S2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
    ]
    public static CFS_REEL_SET_1ST: string[][] = [
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "L1", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "XHOLE", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "S2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
    ]
    public static CFS_REEL_SET_2ND: string[][] = [
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "S2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "XHOLE", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "L1", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
    ]
    public static SFS_REEL_SET: string[][] = [
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "XHOLE", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
    ]
    public static XMENTAL_RESPIN_REELSET: string[][] = [
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "XHOLE", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
        ["L1", "L2", "L3", "L4", "D", "L5", "M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "M1", "M2", "M3", "M4"],
    ]
    public static XHOLE_REELSET: string[] = ["L5", "M2", "L1", "XHOLE", "L5", "M4", "M1", "M2", "L1", "XHOLE", "M3", "M5", "L1", "M2", "L2", "XHOLE", "L3", "M4", "L1", "S1", "M2", "XHOLE", "M3", "M4"];
    public static XMENTAL_REELSET: string[] = ["M2", "L1", "XMENTAL", "L5", "M2", "M3", "L2", "XMENTAL", "L3", "L1", "M2", "XMENTAL", "M3", "M4"];
    public static XGOD_REELSET: string[] = ["TS1", "TS1", "TS1", "TS1", "GOD", "TS1", "TS1", "TS1"];
    public static XGOD_MISS_REELSET: string[] = ["TS1", "TS1", "TS1", "TS1", "TS1", "TS1", "TS1"];
    public static STEP_DURATION: number = 0.04;
    public static REEL_STOP_DELAY: number = Config.STEP_DURATION * 5;
    public static REEL_STOP_DELAY_FAST_SPIN: number = Config.STEP_DURATION * 0.5;
    public static SYMBOL_WIDTH: number = 144;
    public static SYMBOL_HEIGHT: number = 198;
    public static SYMBOL_HEIGHT_HALF: number = 99;
    public static SYMBOLS_IN_REEL: number[] = [3, 2, 3, 2, 3];
    public static SCATTER_ANTICIPATION_DELAY_FAST: number = 1.5;
    public static SCATTER_ANTICIPATION_DELAY_NORMAL: number = 2;
    public static X_GOD_DELAY_FAST: number = 0.5;
    public static X_GOD_DELAY_NORMAL: number = 1;
    public static X_MENTAL_DELAY_NORMAL: number = 3.5;
    public static X_MENTAL_DELAY_FAST: number = 2.5;
    public static XHOLE_ANTICIPATION_DELAY_FAST: number = 0.5;
    public static XHOLE_ANTICIPATION_DELAY_NORMAL: number = 1;
    public static IS_SCATTER_ANTICIPATION_REEL_ACTIVE: boolean[] = [false, false, false, false, false];
    public static MARGIN_TOP: number = -21;
    public static WIN_RATIOS: IWinRatios = {
        normalWin: [
            {
                ratio: 0,
                duration: 0,
                type: WinRatioType.TINY
            },
            {
                ratio: 1.5,
                duration: 0,
                type: WinRatioType.SMALL
            },
            {
                ratio: 3,
                duration: 0,
                type: WinRatioType.MEDIUM
            },
            {
                ratio: 5,
                duration: 0.6,
                type: WinRatioType.LARGE
            }
        ],
        bigWin: [
            {
                from: 0,
                to: 25,
                id: 1,
                ratio: 15,
                duration: 4,
                type: WinRatioType.BIG_WIN_01
            },
            {
                from: 25,
                to: 50,
                id: 2,
                ratio: 25,
                duration: 4,
                type: WinRatioType.BIG_WIN_02
            },
            {
                from: 50,
                to: 100,
                id: 3,
                ratio: 50,
                duration: 4,
                type: WinRatioType.BIG_WIN_03
            },
            {
                from: 100,
                to: 1000,
                id: 4,
                ratio: 100,
                duration: 4,
                type: WinRatioType.BIG_WIN_04
            },
            {
                from: 1000,
                to: Number.MAX_VALUE,
                id: 5,
                ratio: 1000,
                duration: 4,
                type: WinRatioType.BIG_WIN_05
            }
        ]
    };
    public static AVAILABLE_SYMBOL_SIZES: number[] = [198, 148, 132, 118, 99, 84, 74, 66, 60, 56, 50, 45, 40, 32, 26];

    public static REEL_HEIGHT: number[] = [594, 396, 495, 396, 594];
    public static SPLIT_POS: number[][] = [
        [0.0, 1, 0, 1],
        [2, 1, 1, 2, 0],
        [2, 2, 3, 2, 2],
        [2, 2, 3, 2, 2],
    ];

    // #355
    public static BIG_WIN_RATIOS_XMENTAL_BOOSTED_BET: IBigWinLevel[] = [
        {
            from: 0,
            to: 2400,
            id: 1,
            ratio: 1600,
            duration: 4,
            type: WinRatioType.BIG_WIN_01
        },
        {
            from: 2400,
            to: 3000,
            id: 2,
            ratio: 2400,
            duration: 4,
            type: WinRatioType.BIG_WIN_02
        },
        {
            from: 3200,
            to: 4000,
            id: 3,
            ratio: 3200,
            duration: 4,
            type: WinRatioType.BIG_WIN_03
        },
        {
            from: 4800,
            to: 7200,
            id: 4,
            ratio: 4800,
            duration: 4,
            type: WinRatioType.BIG_WIN_04
        },
        {
            from: 7200,
            to: Number.MAX_VALUE,
            id: 5,
            ratio: 7200,
            duration: 4,
            type: WinRatioType.BIG_WIN_05
        }
    ];

    // #355
    public static BIG_WIN_RATIOS_FEATURE_BUYS: IBigWinLevel[] = [
        {
            from: 0,
            to: 100,
            id: 2,
            ratio: 50,
            duration: 4,
            type: WinRatioType.BIG_WIN_02
        },
        {
            from: 100,
            to: 200,
            id: 3,
            ratio: 100,
            duration: 4,
            type: WinRatioType.BIG_WIN_03
        },
        {
            from: 200,
            to: 2000,
            id: 4,
            ratio: 200,
            duration: 4,
            type: WinRatioType.BIG_WIN_04
        },
        {
            from: 2000,
            to: Number.MAX_VALUE,
            id: 5,
            ratio: 2000,
            duration: 4,
            type: WinRatioType.BIG_WIN_05
        }
    ];
}